export default function ReviewShipmentItem({ item }) {
  const UNIT_TRANSLATIONS = {
    count: "عدد",
    package: "بسته",
    weight: "کیلوگرم",
    length: "متر",
    area: "متر مربع",
    litr: "لیتر",
    volume: "متر مکعب",
  };

  const unitPrice = Number(item.unit_price || 0);
  const finalPrice = Number(item.final_price || 0);
  const discountPercent = Number(item.discount_percent || 0);
  const discountAmount = (discountPercent * unitPrice) / 100;

  return (
    <div className="px-5 py-5 sm:px-6">
      <div className="grid grid-cols-1 items-center gap-4 md:grid-cols-12">
        <div className="flex items-center gap-4 md:col-span-6">
          <div className="h-20 w-20 shrink-0 overflow-hidden rounded-xl border border-slate-100 bg-slate-50">
            <img
              src={item.featured_image_url}
              alt={item.name}
              className="h-full w-full object-cover"
            />
          </div>

          <div className="min-w-0">
            <h4 className="line-clamp-2 font-bold leading-6 text-slate-800">
              {item.name}
            </h4>

            <p className="mt-1 line-clamp-1 text-xs text-slate-500">
              {item.category}{" "}
              {item.supplier ? (
                <>
                  <span className="mx-1 text-slate-300">|</span>
                  {item.supplier}
                </>
              ) : null}
            </p>

            <div className="mt-3 flex flex-wrap gap-2 md:hidden">
              <span className="rounded-md bg-slate-100 px-2 py-1 text-xs text-slate-600">
                تعداد: {item.quantity}{" "}
                {UNIT_TRANSLATIONS[item.unit_of_measure] || ""}
              </span>

              {discountPercent > 0 && (
                <span className="rounded-md bg-red-50 px-2 py-1 text-xs font-medium text-red-500">
                  {discountPercent}٪ تخفیف
                </span>
              )}
            </div>
          </div>
        </div>

        <div className="hidden text-center text-sm text-slate-600 md:block md:col-span-2">
          {unitPrice.toLocaleString("fa-IR")}
          <span className="mt-1 block text-[11px] text-slate-400">تومان</span>
        </div>

        <div className="hidden text-center md:block md:col-span-1">
          {discountPercent > 0 ? (
            <>
              <span className="text-sm font-bold text-red-500">
                {discountPercent}٪
              </span>
              <span className="mt-1 block text-[10px] text-red-400">
                {discountAmount.toLocaleString("fa-IR")}
              </span>
            </>
          ) : (
            <span className="text-sm text-slate-300">—</span>
          )}
        </div>

        <div className="hidden text-center text-sm font-medium text-slate-700 md:block md:col-span-1">
          {item.quantity}
          <span className="mr-1 text-xs text-slate-400">
            {UNIT_TRANSLATIONS[item.unit_of_measure] || ""}
          </span>
        </div>

        <div className="flex items-center justify-between rounded-xl bg-slate-50 px-3 py-3 md:col-span-2 md:block md:bg-transparent md:p-0 md:text-left">
          <span className="text-xs text-slate-400 md:hidden">مبلغ کل</span>

          <div className="font-bold text-[#1E3A5F]">
            {finalPrice.toLocaleString("fa-IR")}
            <span className="mr-1 text-xs font-medium text-slate-500">
              تومان
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
